'use client';

import { useRouter } from 'next/navigation';

import { HeaderWrapper } from '@/components/Header/HeaderWrapper';
import { HeaderLogo } from '@/components/Header/HeaderLogo';
import { HeaderSearch } from '@/components/Header/HeaderSearch';
import { HamburgerMenu } from '@/components/Header/HamburgerMenu';
import MegaMenu from '@/components/Header/MegaMenu';

// TODO - replace image imports with Contentful media
import profileImg from '../../../../public/images/profile.png';
import PartnerhubLogoutForm from '../PartnerhubLogoutForm';
import Link from 'next/link';
import { TEntriesResponse } from '@/features/contentful/types/types';
import { TypeMegaMenuComponentWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';
import { normalizeMegaMenu } from '@/features/contentful/helpers/menu';
import { getLocalizedLink } from '@/utils/getLocalizedLink';
import { useState } from 'react';
import CustomImage from '@/components/CustomImage/CustomImage';

const PartnerhubHeader = ({
    megaMenu,
    lang,
}: {
    megaMenu?: TEntriesResponse<TypeMegaMenuComponentWithoutUnresolvableLinksResponse[]>;
    lang?: string;
}) => {
    const router = useRouter();
    const { headerId, headerLinks } = normalizeMegaMenu(lang ?? 'en', megaMenu);
    const headerLogoLink = getLocalizedLink('/clienthub', lang);

    const handleSearch = (val: string) => {
        if (!val || !val.trim()) {
            return;
        }
        const searchParams = new URLSearchParams({ q: val });

        router.push(
            `${getLocalizedLink('/clienthub/search', lang ?? 'en')}?${searchParams.toString()}`,
        );
    };
    const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);

    return (
        <HeaderWrapper>
            <div className="tw-hidden !tw-visible lg:!tw-flex tw-flex-row tw-items-center tw-justify-between">
                <div className="tw-flex tw-flex-row tw-items-center">
                    <HeaderLogo className="tw-cursor-pointer tw-mr-[20px]" link={headerLogoLink} />
                    <MegaMenu links={headerLinks} headerId={headerId} />
                </div>
                <div className="tw-flex tw-flex-row tw-items-center tw-h-[21px]">
                    <HeaderSearch className="tw-mr-4" handleSearch={handleSearch} />

                    <Link href={getLocalizedLink('clienthub/profile')}>
                        <CustomImage
                            src={profileImg}
                            className="tw-cursor-pointer tw-mr-4"
                            alt="Profile icon"
                            width="19"
                            height="21"
                        />
                    </Link>
                    <PartnerhubLogoutForm />
                </div>
            </div>
            <div className="tw-flex tw-flex-row tw-justify-between tw-items-center lg:tw-hidden">
                <div>
                    <HeaderLogo
                        className="tw-cursor-pointer"
                        link={headerLogoLink}
                        closeHamburger={() => setIsHamburgerOpen(false)}
                    />
                </div>
                <div className="tw-flex tw-flex-row">
                    <HeaderSearch className="tw-mr-4" handleSearch={handleSearch} />
                    <HamburgerMenu
                        links={headerLinks}
                        labels={{
                            // For Partnerhub, these labels are hardcoded
                            accessibility: 'Accessibility',
                            contactUs: 'Contact Us',
                            chooseLanguage: 'Choose Language',
                            back: 'Back',
                        }}
                        isHamburgerOpen={isHamburgerOpen}
                        setIsHamburgerOpen={setIsHamburgerOpen}
                    />
                </div>
            </div>
        </HeaderWrapper>
    );
};

export default PartnerhubHeader;
